import styled from 'styled-components';
import { Checkbox } from 'antd5';

export const StyledNotification = styled.div`
  color: ${({ theme }) => theme.headerColor};
`;

export const StyledCheckbox = styled(Checkbox)`
  height: 1rem;
`;
